import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../../../components/common/FormikControl";
import { useEffect, useState } from "react";
import EditorApi from "../../../../services/editorManagementService";
import SubAdminApi from "../../../../services/subAdminService";
import HospitalDropdownApi from "../../../../services/hospitalService";
import { useSelector } from "react-redux";

  const TaskFilter = ({ onApply, onClear, initialFilters  }) => {
  const [productData, setProductData] = useState([]);
  const [allPhaseData, setAllPhaseData] = useState([]);
  const [investigatorOptions, setinvestigatorOptions] = useState([]);
  const [hospitalOptions, setHospitalOptions] = useState([]);
  const userData = useSelector((state) => state.loginData);
  const role_slug=userData.role_slug
   const fetchProductOptions = async () => {
const { loginId } = userData;
let editor_id;
let investigator_id;
let user_id;

if (role_slug === "editor") {
  editor_id = loginId;
} else if (role_slug === "investigator") {
  investigator_id = loginId;
} else if (role_slug !== "superadmin") {
  // For all other roles except superadmin
  user_id = loginId;
}

// API call
const res = await EditorApi.getPhaseDropDown(
  "",                 // search
  investigator_id,
  editor_id,
  user_id
);
  const phases = res.data.map((item) => ({
    label: item.title,          // phase name
    value: item.id,             // phase id
    productId: item.product_details?.id || null,
  }));

  const products = res.data
    .filter((item) => item.product_details)
    .map((item) => ({
      label: item.product_details.name,   // product name
      value: item.product_details.id,     // product id
    }));

  const uniqueProducts = Array.from(
    new Map(products.map((p) => [p.value, p])).values()
  );
   const sortedProducts = uniqueProducts.sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );

  setProductData(sortedProducts);
  setAllPhaseData(phases);
};

  const fetchSubAdminDropdown = async (id) => {
  try {
    const response = await SubAdminApi.getSubAdminDropdown(id);
    const piData = response?.data?.data || response?.data || [];

    const piOptions = piData.map((pi) => ({
      label: pi.name,  
      value: pi.id,     
    }));

    setinvestigatorOptions(piOptions);
  } catch (error) {
    console.error("Error fetching SubAdmin PI list:", error);
    setinvestigatorOptions([]);
  }
};

const getHospitalList = async () => {
  try {
    const res = await HospitalDropdownApi.getHospitalDropDown();
    const hospitalData = res?.data?.data || res?.data || [];
    const options = hospitalData.map((list) => ({
      label: `${list.name} (${list.city_name})`,
      value: list.id,
      name: list.name,
    }));
    
    setHospitalOptions(options);
  } catch (error) {
    console.error("Error fetching hospitals:", error);
    setHospitalOptions([]);
  }
};

  useEffect(() => {
    fetchProductOptions();
    fetchSubAdminDropdown(2)
    getHospitalList();
  }, []);
  useEffect(() => {
}, [productData, allPhaseData, investigatorOptions, hospitalOptions]);


  const initialValues = {
    product: "",
    phase: "",
    investigator: "",
    hospital: "",
    ...initialFilters
  }

  const formOptions = [
    {
      label: 'Product',
      type: 'select',
      name: 'product',
      options: productData
    },
    {
      label: 'Phase',
      type: 'select',
      name: 'phase',
      options: allPhaseData
    },
    {
      label: 'Principal Investigator',
      type: 'select',
      name: 'investigator',
      options: investigatorOptions
    },
    {
      label: 'Hospital',
      type: 'select',
      name: 'hospital',
      options: hospitalOptions,
  }
  ]
  const handleSubmit = (values) => {
  const formattedValues = {
    ...values,

    product_label: productData.find(p => p.value === values.product)?.label || "",
    phase_label: allPhaseData.find(p => p.value === values.phase)?.label || "",
    investigator_label: investigatorOptions.find(i => i.value === values.investigator)?.label || "",
    hospital_label: hospitalOptions.find(h => h.value === values.hospital)?.label || ""
  };

  onApply(formattedValues);
};


  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })

  const handleClear = () => {
    formik.resetForm();
    onClear(null);
  };
  return (
    <Box  sx={{
  }}>
      <form onSubmit={formik.handleSubmit}>
        {formOptions.map((props, key)=>(
          <Grid key={key} item xs={12}    sx={{
            marginTop: '1rem',
            marginBottom: '1rem',
          }}>
          <FormikControl formik={formik} inputClassName={'fixWidthDropdown'} {...props} />
          </Grid>
        ))}
        
        <Box sx={{ display: "flex",justifyContent: "space-between", gap: 2, marginTop: "10px" }}>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  onClick={handleClear} variant="outlined">Clear Filter</LoadingButton>
            <LoadingButton size="large" sx={{ borderRadius: "6px" }}  type="submit" variant="contained">Apply Filter</LoadingButton>
          </Box>
      </form>
    </Box>
  );
}

export default TaskFilter;
